module.exports = __webpack_public_path__ + "static/media/team_apps.57d38482.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/views/docs/img/team_apps.png
// module id = 982
// module chunks = 0